import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { Toaster } from "sonner";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Prospection from "@/pages/Prospection";
import Prospects from "@/pages/Prospects";
import ProspectDetail from "@/pages/ProspectDetail";
import Tasks from "@/pages/Tasks";
import Templates from "@/pages/Templates";
import ProspectMap from "@/pages/ProspectMap";
import Settings from "@/pages/Settings";
import Guide from "@/pages/Guide";
import PublicSite from "@/pages/PublicSite";
import AppLayout from "@/components/AppLayout";

function Protected({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen flex items-center justify-center text-slate-400 font-mono text-sm">Chargement…</div>;
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

const PUBLIC_HOSTS = ["pcup.fr", "www.pcup.fr"];
const isPublicDomain = typeof window !== "undefined" && PUBLIC_HOSTS.includes(window.location.hostname);

function AppRoutes() {
  return (
    <Routes>
      <Route path="/" element={isPublicDomain ? <PublicSite /> : <Navigate to="/dashboard" replace />} />
      <Route path="/login" element={<Login />} />
      <Route path="/site" element={<PublicSite />} />
      <Route element={<Protected><AppLayout /></Protected>}>
        <Route path="dashboard" element={<Dashboard />} />
        <Route path="prospection" element={<Prospection />} />
        <Route path="prospects" element={<Prospects />} />
        <Route path="prospects/:id" element={<ProspectDetail />} />
        <Route path="tasks" element={<Tasks />} />
        <Route path="templates" element={<Templates />} />
        <Route path="map" element={<ProspectMap />} />
        <Route path="settings" element={<Settings />} />
        <Route path="guide" element={<Guide />} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default function App() {
  return (
    <div className="App grain">
      <AuthProvider>
        <BrowserRouter>
          <AppRoutes />
        </BrowserRouter>
        <Toaster theme="dark" position="top-right" richColors />
      </AuthProvider>
    </div>
  );
}
